/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const isAdmin = currentUser?.access === 'admin';
  const adminScope =
    currentUser?.adminScope ||
    currentUser?.admin_scope ||
    (isAdmin ? 'platform' : 'none');
  const adminViews = currentUser?.adminViews || currentUser?.admin_views || [];
  const canPlatformAdmin =
    isAdmin && (adminViews.includes('platform') || adminScope === 'platform');
  const canCompanyAdmin =
    isAdmin && (adminViews.includes('company') || adminScope === 'company');
  const canRegionAdmin =
    isAdmin &&
    (adminViews.includes('region') ||
      adminScope === 'region' ||
      canCompanyAdmin ||
      canPlatformAdmin);

  return {
    canAdmin: isAdmin,
    canPlatformAdmin,
    canCompanyAdmin,
    canRegionAdmin,
    canAdminTenantData: canPlatformAdmin || canCompanyAdmin,
  };
}
